import { connect } from 'react-redux';

import actions from '../../actions';
import ProbingHandles from '../../components/viewer3d/ProbingHandles';
import machines from '../../machines';

import { GHOST_PROBE_ALIGN_TO_NORMAL } from '../../constants/probing';

export default connect(
  (state, ownProps) => ({
    op: state.probing.activeOperation > -1 ? state.probing.program.cmds[state.probing.activeOperation] : {},
    toolLengthOffset: state.machineState.tool.table[state.machineState.tool.loaded].Z,
    machine: machines[state.machineState.machine],
    joints: state.machineState.joints,
    ghostProbeMode: GHOST_PROBE_ALIGN_TO_NORMAL
  }),
  (dispatch, ownProps) => ({
    onSetJoints: (joints) => {
      dispatch(actions.machineState.joints.set(joints));
    },
  })
)(ProbingHandles);
